import Modal from '@/Components/Modal'

export default {
    install(app, options) {

        app.component('Modal', Modal)

    }
}
